import { API, Auth } from "aws-amplify";
import { formatApiError } from "./formatApiError";

export const getAdminAuthHeaders = async (preferIdToken = true) => {
  const session = await Auth.currentSession();
  const accessToken = session.getAccessToken().getJwtToken();
  const idToken = session.getIdToken().getJwtToken();
  return {
    Authorization: preferIdToken ? (idToken || accessToken) : (accessToken || idToken)
  };
};

export const shouldRetryAdminQueries = (error: unknown) => {
  const message = formatApiError(error).toLowerCase();
  return (
    message.includes("network error") ||
    message.includes("not authorized") ||
    message.includes("unauthorized") ||
    message.includes("forbidden") ||
    message.includes("403") ||
    message.includes("401")
  );
};

export const adminGet = async (path: string, queryStringParameters?: Record<string, unknown>) => {
  try {
    return await API.get("AdminQueries", path, {
      headers: await getAdminAuthHeaders(true),
      queryStringParameters
    });
  } catch (error) {
    if (!shouldRetryAdminQueries(error)) {
      throw error;
    }
    return API.get("AdminQueries", path, {
      headers: await getAdminAuthHeaders(false),
      queryStringParameters
    });
  }
};

export const adminPost = async (path: string, body?: Record<string, unknown>) => {
  try {
    return await API.post("AdminQueries", path, {
      headers: await getAdminAuthHeaders(true),
      body
    });
  } catch (error) {
    if (!shouldRetryAdminQueries(error)) {
      throw error;
    }
    return API.post("AdminQueries", path, {
      headers: await getAdminAuthHeaders(false),
      body
    });
  }
};
